export default function quoteClose(params){
  this.popup("closeQuote", {
    params: params,
    header : this.translate("LBL_CLOSE_QUOTE_TITLE", "Quotes")
  });

}